import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import NiceModal from '@ebay/nice-modal-react';
import CreateAddClientModal from 'components/v2/Modals/CreateAddClientModal';

import PlusIcon from './icons/Plus';
import ChangeCircleIcon from './icons/ChangeCircle';

import { useUser } from 'common/hooks/user';

const useStyles = makeStyles(theme => ({
  btn: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    textTransform: 'uppercase',
    height: '100%',
    padding: '0 17px',
    fontWeight: 400,
    lineHeight: 1,
    fontSize: 12,
    cursor: 'pointer',
    transition: theme.transitions.create(['color']),
    '& svg': {
      width: 13,
      height: 13,
    },
    '& path': {
      transition: theme.transitions.create(['fill']),
    },
    '&:hover': {
      color: theme.palette.secondary.main,
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
  },
  client: {
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  icons: {
    '& svg': {
      width: 20,
      height: 20,
    },
  },
}));

const AddClientButton = () => {
  const classes = useStyles();
  const user = useUser();
  const client = user?.client;
  const updateClient = user.updateClient;

  const agencyId = user?.agency?.id;

  return (
    <div
      className={clsx(classes.btn, client && classes.client)}
      onClick={() => {
        NiceModal.show(CreateAddClientModal, {
          title: 'Assign Client',
          subtext: 'Select a client to assign to this itinerary, or create a new client.',
          selectClientButtonText: 'Assign Client',
          canDelete: true,
          agencyId,
          onNewClient: async (client, modal) => {
            await updateClient(client);
            modal.hide();
          },
          onSelectExistingClient: async (client, modal) => {
            await updateClient(client);
            modal.hide();
          },
          onDelete: async (_, modal) => {
            await user.clearClient();
            modal.hide();
          },
          client,
          showCurrentClient: true,
        });
      }}
      role="button"
      aria-label={client ? 'change client' : 'add client'}
    >
      {client ? (
        <>
          <div className={classes.icons}>
            <ChangeCircleIcon />
          </div>
          {client?.name}
        </>
      ) : (
        <>
          <PlusIcon /> <span>Add Client</span>
        </>
      )}
    </div>
  );
};

export default AddClientButton;
